import React from 'react';

import WLIcon from './WLIcon';

const APIErrorsTable = ({ items, className }) => (
  <table className={`StatsTable ${className}`}>
    <colgroup>
      <col width='50px;' />
      <col width='30px;' />
      <col width='140px;' />
      <col width='40px;' />
      <col width='80px;' />
      <col width='150px;' />
      <col width='130px;' />
    </colgroup>
    <tbody>
      <tr>
        <th colSpan='7'>
          <span className='StatsTable_caption'>API Errors</span>
        </th>
      </tr>

      <tr className='StatsTable_innerHeader'>
        <td>Time</td>
        <td colSpan='2'>Store</td>
        <td>Cart</td>
        <td>Endpoint</td>
        <td>Message</td>
        <td>Error</td>
      </tr>

      {items.map((item, index) => (
        <tr key={index}>
          <td>{item.time}</td>
          <td colSpan='2'>
            <WLIcon item={item} index={index} /> {item.storeName}
          </td>
          <td>{item.cartID}</td>
          <td>{item.endpoint}</td>
          <td>{item.request}</td>
          <td>{item.error}</td>
        </tr>
      ))}

      {items.length === 0 && (
        <tr>
          <td colSpan='7' className='StatsTable_none'>
            No Errors
          </td>
        </tr>
      )}
    </tbody>
  </table>
);

export default APIErrorsTable;
